module.exports = __webpack_public_path__ + "static/media/check.c87ba8c8.png";